import type { Setting } from "~/slices/settings/types";

export const transformSettings = (
  settings: Setting[],
): Record<string, Setting> => {
  return settings.reduce(
    (data, conf) => {
      data[conf.attribute.slug] = conf;
      return data;
    },
    {} as Record<string, Setting>,
  );
};
